import { apiUrl, baseUrl } from "../constants";

export const fetchApiKey = ({ username, password }) => {
  let data = new FormData();
  data.append("action", "login");
  data.append("username", username);
  data.append("password", password);
  return new Promise((resolve, reject) => {
    fetch(apiUrl, {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((body) => body.Key)
      .then((key) => {
        sessionStorage.setItem("apikey", key);
        // sessionStorage.setItem("relogin", false);
        // sessionStorage.setItem("multiplelogin", true);
        resolve(key);
      });
  });
};
export const getColorList = async (apiKey) => {
  const formdata = new FormData();
  formdata.append("action", "colordatabase");
  formdata.append("key", apiKey);
  const response = await fetch(apiUrl, {
    method: "POST",
    body: formdata,
  });
  const colordb = await response.json();
  return colordb.ColorTables;
};
export const getDesignThumb = async (apiKey, designs) => {
  const files = designs.map((item) => item.fullPath);
  const formdata = new FormData();
  formdata.append("action", "designthumbs");
  formdata.append("key", apiKey);
  formdata.append("files", JSON.stringify(files));
  const response = await fetch(apiUrl, {
    method: "POST",
    body: formdata,
  });
  const thumbProps = await response.json();
  return designs.map((item) => {
    const fn = thumbProps.find((th) => th.Name === item.fullPath);
    if (!fn) return item;
    return { ...item, thumbUrl: fn.Thumb, props: fn.Props };
  });
};
export const getInterfaceElements = async ({ apiKey }) => {
  const formdata = new FormData();
  formdata.append("action", "interfaceelements");
  formdata.append("key", apiKey);
  const response = await fetch(apiUrl, {
    method: "POST",
    body: formdata,
  });
  const elements = await response.json();
  const interfaceElements = elements.InterfaceElements;
  const { IsAdmin, IsJpeg, CustomizeJsUrl } = interfaceElements;
  const FlagJsonUrl = baseUrl + CustomizeJsUrl;
  let res = await fetch(`${FlagJsonUrl}`, { method: "GET" });
  let flags = "";
  try {
    flags = await res.json();
  } catch (error) {
    console.log("getInterfaceElements -> error", error);
  }
  return { isJpeg: IsJpeg, isAdmin: IsAdmin, flags: flags };
};
export const clearCache = async ({ apiKey, mode, files }) => {
  if (!mode) console.warn("CLEAR CACHE MODE NOT SPECIFIED");
  let data = new FormData();
  data.append("action", "clearcache");
  data.append("key", apiKey);
  data.append("mode", mode);
  if (files) data.append("files", JSON.stringify(files));
  await fetch(apiUrl, {
    method: "POST",
    body: data,
  });
};
